import { getDeviceCode, getPlatformToken } from '../../../../api/device';
import { getDevice } from '../../../../utils/device';

getDeviceCode;
let name;
let secret;
let device = getDevice();
if (device == 'tizen') {
  name = 'samsung_tizen_tv';
  secret = '2A6j1kiPvbsD4yzKVVDLssmkHK_j1g9sf8kwSWXwfH5rfg22XovWb8tMYedCqiEi';
}
if (device == 'webos') {
  name = 'lg_webos_tv';
  secret = 'SWpYU4yzNvaEqPbg4je885UsXRkusQFCFguGWV22qaAWfam-VfoMk22kw6xQ7XeY';
}
if (device == 'web') {
  name = 'samsung_tizen_tv';
  secret = '2A6j1kiPvbsD4yzKVVDLssmkHK_j1g9sf8kwSWXwfH5rfg22XovWb8tMYedCqiEi';
}
export default async function (page) {
  return getPlatformToken(name, secret).then(({ data }) => {
    return getDeviceCode(name, data.token).then(({ data }) => {
      page.token = data.code;
    });
  });
}
